import React from 'react'

import PropTypes from 'prop-types'

import './helicopter-icon-green.css'

const HelicopterIconGreen = (props) => {
  return (
    <div className={`helicopter-icon-green-container ${props.rootClassName} `}>
      <div className="helicopter-icon-green-container1">
        <div className="helicopter-icon-green-container2">
          <img
            alt="heli1"
            src="https://iili.io/HYla7Hv.png"
            className="helicopter-icon-green-image"
          />
        </div>
        <svg
          viewBox="0 0 585.1428571428571 1024"
          className="helicopter-icon-green-icon"
        >
          <path
            d="M585.143 402.286c0 9.714-4 18.857-10.857 25.714l-256 256c-6.857 6.857-16 10.857-25.714 10.857s-18.857-4-25.714-10.857l-256-256c-6.857-6.857-10.857-16-10.857-25.714 0-20 16.571-36.571 36.571-36.571h512c20 0 36.571 16.571 36.571 36.571z"
            className=""
          ></path>
        </svg>
      </div>
    </div>
  )
}

HelicopterIconGreen.defaultProps = {
  rootClassName: '',
}

HelicopterIconGreen.propTypes = {
  rootClassName: PropTypes.string,
}

export default HelicopterIconGreen
